/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { getComponentStylesFactory } from '@/utils/getComponentStylesFactory';
import { getComponentThemeFactory } from '@/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "slide": {
    "image": {
      "size_default": "min-w-25 sm:min-w-37.5 max-w-40 sm:max-w-60"
    }
  },
  "swiper": {},
  "disclaimer_line_variant_default": "text-center border-b",
  "disclaimer_line_colors_default": "border-gray-500",
  "disclaimer_line_size_default": "mb-4 md:mb-9 h-3.5",
  "disclaimer_colors_default": "text-black bg-white",
  "disclaimer_size_default": "text-headline-2xs px-3 md:px-3",
  "disclaimer_variant_default": "uppercase",
  "title_variant_default": "",
  "title_colors_default": "",
  "title_size_default": "text-headline-xs py-1 md:pt-3 md:pb-1",
  "price_variant_default": "after:content-[\":-\"] font-bold",
  "price_colors_default": "",
  "price_size_default": "text-headline-xs py-1 md:pb-3",
  "colors_default": "",
  "size_default": "w-screen ml-[-50vw] md:w-full md:ml-0",
  "variant_default": "relative left-1/2 md:left-0 not-prose"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "AffiliateGallery");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;